import {
  optimizationEventOpens,
  optimizationEventClicks,
  optimizationEventReads,
  optimizationEventLinkClicks,
} from "@canvas/Steps/ContentOptimizationStep/constants";

import type { ChannelOptimizationEventConfig, ContentOptimizationChannel } from "./types";

const baseChannelOptimizationEvents: Record<ContentOptimizationChannel, ChannelOptimizationEventConfig> = {
  email: {
    allowed: [optimizationEventOpens, optimizationEventClicks],
    default: optimizationEventClicks,
  },
  push: {
    allowed: [optimizationEventOpens],
    default: optimizationEventOpens,
  },
  sms: {
    allowed: [optimizationEventLinkClicks],
    default: optimizationEventLinkClicks,
  },
};

const rcsOptimizationEvents: ChannelOptimizationEventConfig = {
  allowed: [optimizationEventClicks, optimizationEventReads],
  default: optimizationEventClicks,
};

export function getOptimizationEventConfig(
  channel: ContentOptimizationChannel,
  smsProtocol?: string | null
): ChannelOptimizationEventConfig {
  if (channel === "sms" && smsProtocol === "rcs") {
    return rcsOptimizationEvents;
  }
  return baseChannelOptimizationEvents[channel];
}
